/**
 * 根据发牌方式构建轮发队列，供单机与联机动画共用。
 *
 * @param {Array<{id: string}>} players - 玩家列表（顺序决定轮发先后）
 * @param {Object<string, Array>} handsByPlayerId - 各玩家手牌；未知玩家可省略或传空数组
 * @param {string} dealMode - single | 223 | 334 | 553 | thirteen
 * @returns {Array<{playerId: string, card: *}>}
 */
export function buildDealingQueue(players, handsByPlayerId, dealMode = 'single') {
  const playerCount = players.length
  if (playerCount === 0) return []

  const cardIndexes = {}
  players.forEach(player => {
    cardIndexes[player.id] = 0
  })

  const nextCard = (playerId) => {
    const hand = handsByPlayerId[playerId] || []
    const idx = cardIndexes[playerId]
    cardIndexes[playerId] = idx + 1
    return hand[idx] || null
  }

  const queue = []
  const mode = dealMode || 'single'

  const pushBatchRound = (batchSize) => {
    for (let p = 0; p < playerCount; p++) {
      const playerId = players[p].id
      for (let b = 0; b < batchSize; b++) {
        queue.push({ playerId, card: nextCard(playerId) })
      }
    }
  }

  if (mode === '223') {
    ;[2, 2, 3, 3, 3].forEach(pushBatchRound)
  } else if (mode === '334') {
    ;[3, 3, 4, 1, 1, 1].forEach(pushBatchRound)
  } else if (mode === '553') {
    ;[5, 5, 1, 1, 1].forEach(pushBatchRound)
  } else if (mode === 'thirteen') {
    for (let p = 0; p < playerCount; p++) {
      const playerId = players[p].id
      for (let b = 0; b < 13; b++) {
        queue.push({ playerId, card: nextCard(playerId) })
      }
    }
  } else {
    for (let round = 0; round < 13; round++) {
      for (let p = 0; p < playerCount; p++) {
        const playerId = players[p].id
        queue.push({ playerId, card: nextCard(playerId) })
      }
    }
  }

  return queue
}
